import { createResource } from 'solid-js'
import { useService } from 'solid-services'
import { useSingle } from '.'
import { getCurrentSetupChannel } from './resource/getCurrentSetupChannel'

export function useSingleChat() {
	const { setupId } = useService(useSingle)()

	const [currentChannelResource] = createResource(setupId, getCurrentSetupChannel)
	const currentChannelId = () => currentChannelResource()?.id

	return {
		currentChannelId,
	}
}
